export const BionanoaxusProductMessages = {
  title: "Bionanoaxus",
  description:
    "Alternativa ecológica a las composiciones antimicrobianas tradicionales de especial interés para el tratamiento de agentes patógenos de la industria agrícola, así como para desinfección de múltiples materiales en la industria de alimentos y textil.",
};
